"use client";

import { format, differenceInDays } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
import { fr } from 'date-fns/locale';
import { DateLabelType } from '../types';

interface Props {
  isoDate: string;
  type?: DateLabelType;
  color?: 'default' | 'lighter' | 'dark' | 'gray' | 'none';
  styles?: string;
}

export default function DateLabel({
  isoDate,
  type = 'default',
  color = 'default',
  styles = '',
}: Props) {
  if (!isoDate) {
    return null;
  }
  const date = new Date(isoDate);
  let textColor = 'text-slate-500';
  switch (color) {
    case 'lighter': {
      textColor = 'text-white/60';
      break;
    }
    case 'dark': {
      textColor = 'text-slate-900';
      break;
    }
    case 'gray': {
      textColor = 'text-gray-400';
      break;
    }
    case 'none': {
      textColor = '';
      break;
    }
  }

  const timeZone = 'Europe/Paris';
  ///const zonedDate = toZonedTime(date, timeZone);
  const zonedDate = date;

  let formattedDate = format(zonedDate, 'd MMM yyyy', { locale: fr });

  switch (type) {
    case 'full': {
      formattedDate = format(zonedDate, 'EEEE d MMM yyyy', { locale: fr });
      break;
    }
    case 'live': {
      formattedDate = format(zonedDate, "d MMM HH'h'mm", { locale: fr });
      break;
    }
    case 'year': {
      formattedDate = format(zonedDate, 'yyyy', { locale: fr });
      break;
    }
    case 'time': {
      formattedDate = format(zonedDate, "HH'h'mm", { locale: fr });
      break;
    }
    case 'since': {
      const zonedTodayDate = toZonedTime(new Date(), timeZone);
      const daysSince = differenceInDays(zonedTodayDate, date);
      const daysSinceDays = daysSince > 1 ? `${daysSince} jours` : `${daysSince} jour`;
      if (daysSince <= 5) {
        formattedDate = `Il y a ${daysSinceDays}`;
      }
      if (daysSince === 0) {
        formattedDate = `Aujourd'hui`;
      }
      break;
    }
    case 'dd/MM/yyyy': {
      formattedDate = format(date, 'dd/MM/yyyy', { locale: fr });
      break;
    }
    case 'dd/MM/yyyy HH:mm': {
      formattedDate = format(date, "dd/MM/yyyy HH'h'mm", { locale: fr });
      break;
    }
    case 'd MMMM yyyy HH:mm': {
      formattedDate = format(date, "d MMMM yyyy HH'h'mm", { locale: fr });
      break;
    }
    case 'd MMMM yyyy': {
      formattedDate = format(date, 'd MMMM yyyy', { locale: fr });
      break;
    }
    case 'MMM yyyy': {
      formattedDate = format(date, 'MMM yyyy', { locale: fr });
      break;
    }
    default: {
    }
  }

  return <span suppressHydrationWarning={true} className={`${textColor} ${styles}`}>{formattedDate}</span>;
}
